import { createSelector } from 'reselect';
import { APP_DOMAIN } from './constants';
import { initialState } from './reducer';

const selectRouter = state => state.router;

const selectAppDomain = state => state[APP_DOMAIN] ?? initialState;

const selectUIDomain = state => selectAppDomain(state).UI;

const makeSelectLocation = () =>
  createSelector(
    selectRouter,
    routerState => routerState.location,
  );

export const selectUI = () =>
  createSelector(
    selectUIDomain,
    UI => UI,
  );

export const makeSelectRequireFullWidth = () => {
  return createSelector(
    selectUIDomain,
    UI => {
      console.log('render full ' + Object.keys(UI.fullWidth).length);
      return Object.keys(UI.fullWidth).length;
    },
  );
};

export const selectUIToggle = name => {
  return createSelector(
    selectUIDomain,
    UI => {
      return UI.toggles[name];
    },
  );
};

export { makeSelectLocation };
